import http, { expandURI } from '@/utils/ajax'
import { NON_TRADE_INIT_LOADING, NON_TRADE_INIT_SUCCESS, NON_TRADE_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async nonTradeInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.nonTrade
    const expand = {}
    if (apiUrl) {
      commit(NON_TRADE_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(NON_TRADE_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(NON_TRADE_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(NON_TRADE_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
